import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ConfettiOption: LazyOption = createLazyOption(
    {
        key: 'confetti',
        titleStringKey: 'optionTitle_confetti',
        searchTermsStringKey: 'optionTitle_confetti',
    },
    lazyFullModule,
    m => m.default
);
export default ConfettiOption;
